import BaseApi from './BaseApi';
import { ApiPaths } from './ApiPaths';

/**
 * API for setting and retrieving client tax documents
 */
const create = () => {  
    
    const api = BaseApi.create();
    
    const getCompletedFileInfo = (taxYear) => api.get(ApiPaths.COMPLETED_TAX_DOCUMENTS(taxYear));
    const getDocumentsForReview = (taxYear) => api.get(ApiPaths.COMPLETED_TAX_DOCUMENTS_FOR_REVIEW(taxYear));
    const getApprovalDocuments = (taxYear) => api.get(ApiPaths.COMPLETED_TAX_DOCUMENTS_FOR_APPROVAL(taxYear));

    const setFileViewed = (fileId, taxYear) => {
        var payload = {
            fileId,
            taxYear
        }
        return api.get(ApiPaths.SET_FILE_VIEWED, payload);
    }

    const sendOneTimeSMS = (targetRoute, taxYear) => {
        var payload = {
            TargetRoute: targetRoute,
            TaxYear: taxYear
        }
        return api.post(ApiPaths.SEND_ONE_TIME_SMS, payload)
    }

    const redeemOneTimeCode = (code) => {
        var payload = {
            Token: code
        }
        return api.post(ApiPaths.REDEEM_ONE_TIME_CODE, payload)
    }

    const setFileWasUploaded = (taxYear) => {
        var payload = {
            taxYear
        }
        return api.post(ApiPaths.SET_FILE_WAS_UPLOADED, payload)
    }

    const uploadstepcompleted = (taxYear, isComplete) => {
        var payload = {
            taxYear,
            isComplete
        }
        return api.post(ApiPaths.UPLOAD_STEP_COMPLETED, payload);
    }

    const setApprovalComplete = (taxYear) => {
        var payload = {
            taxYear
        }
        return api.post(ApiPaths.SET_APPROVAL_COMPLETE, payload)
    }

    const sendReviewCompleteMessage = (action) => {
        var payload = {
            accountId: action.accountId,
            caseId: action.caseId
        }
        return api.post(ApiPaths.SEND_REVIEW_COMPLETE_MESSAGE, payload)
    }

    const sendReviewCompleteMessageWetSignature = (action) => {
        var payload = {
            accountId: action.accountId,
            caseId: action.caseId
        }
        return api.post(ApiPaths.SEND_REVIEW_COMPLETE_MESSAGE_WET_SIGNATURE, payload)
    }

    const getSuggestions = (taxYear) => api.get(ApiPaths.GET_SUGGESTIONS(taxYear));

    // Return back a collection of functions
    return {
        setFileViewed, sendOneTimeSMS, redeemOneTimeCode,
        getCompletedFileInfo, setFileWasUploaded, uploadstepcompleted,
        getDocumentsForReview, getApprovalDocuments, setApprovalComplete, sendReviewCompleteMessage, sendReviewCompleteMessageWetSignature,
        getSuggestions
    }
}

// let's return back our create method as the default.
export default {
    create
}